<template lang="pug">	
	.easy-creative--results.max-limited
		.flex-col.space-medium.full-width.align-center(:class="{ 'disabled-controls': isLoading }")
			template(v-if="info.mode === 'questions'")
				.font-big {{$tCaption('Thank you!')}}
				.flex-row.space.wrap.align-center.center
					template(v-if="!isDone")
						.tile.flex-col.space-large.align-center.center(v-if="info.mode === 'questions'", @click="$emit('back')")
							.flex-row.space.align-center
								.font-large
									fas(icon="chevron-left", size="xs")
									span {{' '}}
									span {{$tCaption('Back')}}
						.tile.flex-col.space-large.align-center.center.success(@click="finishCreative")
							.flex-row.space.align-center
								.font-large
									fas(icon="check", size="xs")
									span {{' '}}
									span {{$tCaption('Finish')}}
					template(v-else)
						.font-big {{$tCaption('Your creative has been generated successfully!')}}
				a.flex-row.align-center.space(@click="downloadSurvey")
					fas(icon="download", size="xs")
					span {{$tCaption('Download the completed brief results')}}
			template(v-if="info.mode === 'templates'")
				.flex-col.space-large.full-width(v-if="!generatedCreative")
					CreativeTemplatesNewCreative(:templateFields="templateFields", :name.sync="newCreativeName")
					.flex-row.justify
						DxButton(:text="$tCaption('Back', '@actions')", icon="fas fa-chevron-left", @click="$emit('back')")
						DxButton(:text="$tCaption('Create', '@actions')", icon="fas fa-check", type="success", @click="newTemplateCreative")
				template(v-else)
					.flex-row.space.wrap.align-center.center
						.tile.flex-col.space-large.align-center.center(@click="$emit('back')")
							.flex-row.space.align-center
								.font-large
									fas(icon="chevron-left", size="xs")
									span {{' '}}
									span {{$tCaption('Back')}}	
						.tile.flex-col.space-large.align-center.center(@click="openGeneratedCreative")
							.flex-row.space.align-center
								.font-large
									fas(icon="magnifying-glass", size="xs")
									span {{' '}}
									span {{$tCaption('Open creative')}}
		Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions') + '..'", :fullscreen="true")
</template>

<script>
	import axios from 'axios';
	import _ from 'lodash';
	import creativeUpdater from 'view/creative/updater';
	import Loader from 'app-core/Loader.vue';
	import CreativeTemplatesNewCreative from 'view/creative/CreativeTemplatesNewCreative.vue';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative-results',
		props: ['info'],
		components: {
			Loader, CreativeTemplatesNewCreative, DxButton
		},
		data() {
			return {
				isLoading: false,
				newCreativeName: null,
				templateFields: [],
				template: null,
				generatedCreative: null,
				isDone: null
			};
		},
		computed: {
			canOpenCreative() {
				return this.info?.brief?.OpenCreativeStudio && this.$auth.hasCreativeApi();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeResults = this;
			this.assignTemplateFields();
		},
		methods: {
			openGeneratedCreative() {
				if (this.generatedCreative?.Oid && this.canOpenCreative) {
					this.$router.push({ path: `/creative/Detail/${this.generatedCreative.Oid}` });
				}
			},
			assignTemplateFields() {
				if (this.info.mode === 'templates') {
					this.isLoading++;
					this.template = this.getSelectedTemplate();
					this.newCreativeName = this.$tCaption('New creative');
					this.isTemplateGenerated = false;
					this.generatedCreative = null;
					this.$Data
						.getExternalApi(
							'Creative/GetCreative',
							`creativeId=${this.template?.Oid}`
						)
						.then((templateItem) => {
							this.templateFields = templateItem.JsonConfig?.templateFields || [];
						})
						.finally(() => this.isLoading--);
				}
			},
			getSelectedTemplate() {
				const templates = this.info.templates();
				return templates?.selectedTemplate;
			},
			downloadSurvey() {
				const questions = this.info.questions();
				if (questions) {
					questions.getFormedResultsRTF(true);
				}
			},
			async newTemplateCreative() {
				this.$notifyMessage(this.$tCaption('Started generating creative "<NAME>"').replace('<NAME>', this.newCreativeName), { busy: true, type: 'warning' })
				this.isLoading++;
				return this.$Data
					.postExternalApi('Creative/CreateCreativeFromTemplate', {
						TemplateId: this.template?.Oid,
						CreativeName: this.newCreativeName,
						TemplateFields: this.templateFields.map(f => this.$Data.formatObjectToUpperCase(f)),
						AdjustLengthToTemplate: this.template?.JsonConfig?.adjustLengthToTemplate !== false
					})
					.then((r) => {
						if (__DEBUG__)
							console.debug('CreateCreativeFromTemplate', { r });
						this.generatedCreative = r?.Data;
					})
					.finally(() => {
						this.isLoading--;
					});
			},
			async finishCreative() {
				if (this.isDone) return;

				this.isLoading++;
				try {

					const scriptBuilder = this.info.scriptBuilder();
					const creative = await this.info.audioGenerator().getCreative();
					const questions = this.info.questions();

					this.$Data.postExternalApi('Service/CreateUpdateObjects', [{
						Id: creative?.Oid,
						Type: this.$Data.objectTypes.Creative,
						Fields: [{
							Name: 'IsTemporary',
							Value: false
						}]
					}]);

					(scriptBuilder?.images || []).map(f => {
						if (f.blobPromise) {
							f.blobPromise.then(blob => {
								return this.$azure.uploadBlobWithInfoResponse(`image_${this.$Data.uuid()}${f.imageUrl.indexOf('.png') > -1 ? '.png' : '.jpeg'}`, blob, 'other').then(r => {
									return this.$Data.postExternalApi('CreativeImage/CreateUpdate', {
										...r,
										Creative: {
											Oid: creative.Oid
										},
										AzureAccount: {
											Oid: r.AzureAccountOid
										}
									})
								});
							});
						}
					});

					if (__DEBUG__)
						console.debug('newBriefCreative', { creative });

					if (this.info?.brief?.ShowProducerRequest) {
						const question = this.info?.producerRequest()?.text;
						if (question) {
							this.$Data.postExternalApi('AudioProducer/AskExpert', {
								Question: question,
								CreativeId: creative?.Oid
							});
						}
					}

					const canPublish = !this.info.integration?.settings?.JsonConfig?.RequireCreativeApprove;
						
					const publishEmail = questions?.getCreativePublishEmail() || this.info.integration?.email;
					if (publishEmail && canPublish) {
						const publishData = new FormData();
						publishData.append('creativeId', creative?.Oid);
						publishData.append('recipientsEmail', publishEmail);

						this.publicationStatisticData = { InProgress: 1, LastSession: { Status: 0 } };
						await axios.post(this.$Data.getMethodUrl('postExternalApi?method=creative/PublishCreative'), publishData, {
							headers: {
								'Content-Type': 'multipart/form-data',
								authToken: this.$auth.accessToken(),
								...__HEADERS__
							}
						}).then(r => {
							if (__DEBUG__)
								console.debug('Publication result', { r });
							if (r?.data?.ErrorMessage) {
								this.$notifyMessage(r?.data?.ErrorMessage, { icon: 'times', type: 'error' });
							} else {
								this.$notifySuccess('Creative is publishing. When the process is complete, you will be notified via email. ');
							}
						}).finally(() => {
							this.$eventsBus?.$emit('notification-busy', false);
							if (this._isDestroyed) return;
							this.$emit('publish-initialized', this.creative);
						});
					}

					if (creative?.Oid) {
						if (this.canOpenCreative) {
							this.$router.push({ path: `/creative/Detail/${creative?.Oid}` });
						} else {
							if (!publishEmail) {
								this.$notifySuccess(this.$tCaption('Creative has been generated.'));
							} else {
								if (!canPublish) {
									this.$notifySuccess(this.$tCaption('Your ad was created successfully but is pending approval'));
								}
							}
						}
					}

					this.isDone = true;
				} finally {
					this.isLoading--;
				}
			}
		}
	};
</script>
<style lang='scss'>

</style>
